import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressSummary = ({ questionsCompleted = 25 }) => {
  return (
    <div className="w-full max-w-md mx-auto mb-8 md:mb-10">
      <div className="bg-primary/5 border border-primary/20 rounded-xl p-4 md:p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 md:gap-4">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary flex items-center justify-center">
              <Icon name="CheckCircle2" size={24} color="white" />
            </div>
            <div>
              <p className="text-sm md:text-base font-medium text-foreground">
                Assessment Complete
              </p>
              <p className="text-xs md:text-sm text-muted-foreground">
                {questionsCompleted} questions answered
              </p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-2xl md:text-3xl font-bold text-primary">
              100%
            </p>
            <p className="text-xs md:text-sm text-muted-foreground">
              Done
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressSummary;